import React, { useEffect } from 'react'
import { ProgressPane } from '@pff-consumer/feature-fantasy/web/lib/progress-pane/progress-pane.web'
import { CurrentProgressState } from '@pff-consumer/schema'
import { useRouter } from 'next/router'
import { Button } from '../common/button/button'
import { useStyles } from './create-account-error.styles'
import { CreateAccountErrorProps } from './create-account-error.props'

export const CreateAccountError = ({ error, onClick }: CreateAccountErrorProps) => {
  const router = useRouter()
  const styles = useStyles()

  useEffect(() => {
    router.push({ query: { success: false, message: error } }, undefined, { shallow: true })
  }, [])

  return (
    <div className={styles.createAccountContainer}>
      <ProgressPane
        state={CurrentProgressState.ERROR}
        header='Account Creation Failed'
        message={`We went for it on 4th and missed. Let's get another drive going and try again!`}
      >
        <Button
          className={styles.button}
          text='TRY AGAIN'
          role='button'
          variant='Primary'
          type='button'
          onClick={onClick}
        />
      </ProgressPane>
    </div>
  )
}
